/**
 * Created by Miguel on 23/05/2017
 */
import { Component, OnInit,ChangeDetectionStrategy, ViewEncapsulation  } from '@angular/core';
import { ActivatedRoute,RouterLink,Router} from '@angular/router';

import { Subscription } from 'rxjs/Subscription';
import { EventBean } from '../../beansts/Event';
import { CompanyService }  from '../../services/company.service';
import { AppDataService }  from '../../services/app-data.service';
import {Meta, Title} from "@angular/platform-browser";
import {Observable}      from 'rxjs/Observable';
import {UserService} from "../../services/user.service";
declare let swal: any;
declare var $ : any;

declare var require: any;
declare let Instafeed: any;
declare var google: any;
declare var FB: any;

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector : 'instagram',
    templateUrl:'instagramcomponent.html',
    providers  : []
})
export class InstagramComponent implements OnInit {

  public list;
  public token;
  public instaAccount;
  public medias=[{id:1,thumbnail:'https://images.unsplash.com/photo-1541963463532-d68292c34b19?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8MXx8fGVufDB8fHx8&w=1000&q=80',comments:10},
  {id:2,thumbnail:'https://images.unsplash.com/photo-1556103255-4443dbae8e5a?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8cGhvdG9ncmFwaGVyfGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&w=1000&q=80',comments:10},
  {id:3,thumbnail:'https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__480.jpg',comments:14}];
  

    constructor(private _routeParams: ActivatedRoute ,
        private _router: Router ,private _companyService : CompanyService, public _appData : AppDataService,private _auth : UserService) {
    }


    public getUserOnInstagram(){
        //THIS IS THE KEY FOR INSTAGRAM USER COLLECTION
//        const routeFragment: Observable<string> = this._routeParams.fragment;
        this._routeParams.queryParams.subscribe(params => {
  //      routeFragment.subscribe(fragment => {
          if (!params.code) return;
          try{
            var fcode=params.code//this is the entire code that comes from the event or login
            this._appData.token=fcode;
            if (fcode){
                console.log(fcode)
    //          $('#loadingModal').modal("show");
              $.ajax({
                url: 'https://api.instagram.com/oauth/access_token',
                type: "POST",
                crossDomain: true,
                dataType: "jsonp",
                data: {client_id:'973086276794950',client_secret:'ef6b25f10e4ed6de0b0015af087886d4',grant_type:'authorization_code',redirect_uri:'https://liveparty.com.br/fbAuth/',code:fcode},
                success: (value)=>{
                    console.log(value)
                }
              });//end ajax
            }//end if code
          }//end try
          catch (err){
    
          }
        })//end route fragment
                  //start searching for user on database...
    /*              this._companyService.authenticateInstagram(id.toString()).then(snapshot2 => {
                    var data2=null;
                    snapshot2.forEach(doc => {
                      data2=(doc.data());
                      }
                    );
                    if (!data2) {
                      //create user
                      //ON ERROR I NEED TO REGISTER
                      this._companyService.registerUser(username+"@coolkids.com.br",id).then((result) => {
                        let uid=result.user.uid;
                        data.uid=uid;
                        data.sex='M';
                        data.avatar='/assets/characters/h1.png';
                        data.kind=0
                        data.vippoints=30;
                        if (localStorage) {
                          let variables=localStorage.getItem('loginVariables');
                          let jvar=JSON.parse(variables);
                          if (jvar){
                            let sex=jvar.gender;
                            if (!sex) sex='M'
                            data.sex=sex;
                            let avatar=jvar.avatar;
                            if (!avatar) avatar='/assets/characters/h1.png';
                            data.avatar=avatar;
                          }
                        }        
                        this._companyService.updateFirebaseUserProfile(data).then((res)=>{                      
                            this.finishInstagramLogin(data);
                        })
                        .catch(function(error) {
                          console.log('ERRO NUMBER 1'+error)
                          swal({
                            title: 'Erro!!!',
                            text: "Houve um erro atualizando seu registro...Tente de novo.",
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'OK'
                          })
                            
                        });
                      })
                      .catch(erroRegister=>{
                        console.log('ERRO NUMBER 2'+erroRegister)
                        swal({
                          title: 'Erro!!!',
                          text: "Houve um erro no seu registro...Tente de novo.",
                          confirmButtonColor: '#3085d6',
                          confirmButtonText: 'OK'
                        })
    
                      })
                    }        
                    else {
                      //update image
                      data2.profile_picture=data.profile_picture;
                      this.finishInstagramLogin(data2);
                    }
                  })
                  .catch(err => {
                      console.log('ERRO NUMBER 3'+err)
    
                      swal({
                        title: 'Erro!!!',
                        text: "Houve um erro na comunicação com nossos servidores...Tente de novo.",
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'OK'
                      })
                  });            
                }
            });
    /*
    
            }//end if code
          }//end try
          catch(err){
            console.log('ERRO NUMBER 4'+err)
            swal({
              title: 'Erro!!!',
              text: "Houve um erro na comunicação com o instagram. Tente de novo.",
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'OK'
            })
          }
          },
          (errorMessage : string) => {
            console.log('ERRO NUMBER 5'+errorMessage)
            swal({
              title: 'Erro!!!',
              text: "Houve um erro na comunicação com o instagram. Tente de novo.",
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'OK'
            })
          })
    */
      }
    
      public finishInstagramLogin(value){
    ////////////////////////////////////////here i organize my data and my presence on list
              /*  try{
                  $('#loadingModal').modal('hide');
                }
                catch (err){}*/
                var res =value;
                if (!res.full_name) res.full_name='Sem nome';
                this._appData.instagramUser=res;
                let variables=null;
                
                if (localStorage) {
                  variables=localStorage.getItem('loginVariables');
                  variables=JSON.parse(variables);
                }
                if (variables && variables.event){
                    let event=variables.event;
                    this._appData.event.id=event;
                    this._router.navigate(['/gameevent/'+event]) 
                }
                else{
                  this._appData.event.id=1592880902713;
                  this._router.navigate(['/gameevent/1592880902713/']) 
                }
                    
                    let promoter=variables.promoter;
                    if (!promoter) promoter="";
                    let user=this._appData.instagramUser;
                    user.list=variables.list;
                    if (!user.list){
                      user.list='0';
                    }
                    //user.full_name=variables.full_name;
                    user.invisible=variables.invisible;
                    user.sex=variables.sex;
                    if (!user.sex) user.sex='M';
                    user.avatar=variables.avatar;
                    if (!user.avatar) user.avatar="/assets/characters/h1.png";
                    if (!user.invisible){
                      user.invisible=false;
                    }
                    let myevent=new EventBean();
                    if (promoter && promoter.length>0){
    
                      this._companyService.updateUserOnList(user,myevent,promoter,variables.list).then((value)=>{
                            let myuser=this._appData.instagramUser
                            if (!myuser.cpf) myuser.cpf=''
                            if (!myuser.phone) myuser.phone=''
                            if (!myuser.email) myuser.email=''
                            if (!myuser.full_name) myuser.full_name=''
                            if (!myuser.profile_picture) myuser.profile_picture=''
                            let userOnList={
                              cpf:myuser.cpf,
                              email:myuser.email,
                              full_name:myuser.full_name,
                              list:variables.list,
                              phone:myuser.phone,
                              profile_picture:myuser.profile_picture,
                              promoter:promoter,
                              uid: myuser.uid,
                              checkin:0,
                              checkout:0,
                              paid:0,
                            }
                            if (localStorage) {localStorage.setItem('instagramUser',JSON.stringify(this._appData.instagramUser))}
                            if (localStorage) {localStorage.setItem(event+'_'+promoter+"_"+variables.list,JSON.stringify(userOnList))}
                            this._router.navigate(['/event/'+event+'/'+promoter+'/'+variables.list]) 
                        });
                      }
                      else{
                        //AddToEvent
                        user=this._appData.instagramUser;
                        if (!user.fcmToken) user.fcmToken='';
                        if (!user.token) user.token='';
                        if (!user.bio) user.bio='';
                        if (!user.username) user.username='';
                        if (!user.profile_picture) user.profile_picture='';
                        if (!user.full_name) user.full_name='Sem nome';
                        if (!user.vippoints) user.vippoints=0;
                        if (!user.birthdate) user.birthdate=0;
                        if (!user.neighbour) user.neighbour='Não informado';
                        if (!user.sex) user.sex="M";
                        if (!user.avatar) user.avatar="/assets/characters/h1.png";
                        user.active=true;
                        $('#loadingModal').modal('hide'); 
                        
                        this._companyService.getPartyMember(myevent,user).get().then(snapuser=>{
                          console.log(snapuser);
                          var shouldadd=true;
                          if (snapuser) {
                            let dbuser=snapuser.data();
                            if (dbuser){
                              shouldadd=false;
                              this._router.navigate(['/gameevent/'+event]) 
                            } 
                          }
                          if (shouldadd) {
                            console.log('should add user'+user);
                              this._companyService.addToLove(myevent,user).then((val)=>{
                                this._router.navigate(['/gameevent/'+event]) 
                              })                
                          }
                        })                
    
      //                }
                    this._companyService.updateFirebaseUserProfile(this._appData.instagramUser);
                  }
    
    }

    public onFacebookButtonClicked() {
        FB.getLoginStatus((response) => {
          if (response.status === 'connected') {
              this.token=response.authResponse.accessToken
              console.log(`token:`+response.authResponse.accessToken)
              this.getUserprofileDetails(response.authResponse.accessToken);
          } 
          else {
              FB.login((loginResponse) => {
                  this.token=loginResponse.authResponse.accessToken
                  console.log(`token:`+loginResponse.authResponse.accessToken)     
                  this.getUserprofileDetails(loginResponse.authResponse.accessToken);
              }, {scope: 'public_profile,email,pages_show_list,instagram_basic'});
          }
        });
    }
    public selectAccount(account){
      let id=account.id;
      let name=account.name;
      $.ajax({
        url: "https://graph.facebook.com/v10.0/"+id+"?fields=instagram_business_account&access_token="+this.token,
        type: "GET",
        crossDomain: true,
        dataType: "jsonp",
        success: (value)=>{
          this.instaAccount=value.instagram_business_account.id;
          this._appData.instagramUser.instaAccount=this.instaAccount;
          //this._companyService.updateUserProperty("instaAccount",instaaccount,this._appData.instagramUser);
          this.getMedias();
        },
        error: (value)=>{

        }
      });//end ajax  
      this.instaAccount='a'

    }
    public getMedias(){
      $.ajax({
        url: "https://graph.facebook.com/v10.0/"+this._appData.instagramUser.instaAccount+"/media?access_token="+this.token,
        type: "GET",
        crossDomain: true,
        dataType: "jsonp",
        success: (value)=>{
          let mediaList=value.data;
          this.medias=[];
          mediaList.array.forEach(element => {
            let id=element.id;
            $.ajax({
              url: "https://graph.facebook.com/v10.0/"+id+"?fields=ig_id,comments_count,like_count,media_url,timestamp&access_token="+this.token,
              type: "GET",
              crossDomain: true,
              dataType: "jsonp",
              success: (value)=>{
                let media=value.data;
                this.medias.push(media);
              }
            });
          });
        }
      });//end ajax  

    }
    public getUserprofileDetails(token: any) {
      if (this._appData.instagramUser.instaAccount){
        this.getMedias();
      }
      else{
        $.ajax({
          url: 'https://graph.facebook.com/v10.0/me/accounts?access_token='+token,
          type: "GET",
          crossDomain: true,
          dataType: "jsonp",
          success: (value)=>{
            let arr=value.data;
            if (!arr || arr.length==0){
              arr=[]
              arr.push({name:"viplistas_oficial",id:"123"})
            }
            this.list=arr;
          }
        });//end ajax  
      }
    }
    public ngOnInit() : any {
//        this.getUserOnInstagram();
      this.list=[];
      this.list.push({name:"viplistas_oficial",id:"123"})

            (window as any).fbAsyncInit = function() {
                FB.init({
                 appId      : '571069763859232',
                 cookie     : true,
                 xfbml      : true,
                 version    : 'v10.0'
               });
                 
               FB.AppEvents.logPageView();   
                 
             };

        
        


    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+integrationCode/instagram.component.ts